/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Studyprograms_Study_Sports_Science19Inputs */

const en__field__enum_studyprograms_study_sports_science19 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Sports_Science19Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sports Science`)
};

const de__field__enum_studyprograms_study_sports_science19 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Sports_Science19Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sportwissenschaft`)
};

/**
* | output |
* | --- |
* | "Sports Science" |
*
* @param {_Field__Enum_Studyprograms_Study_Sports_Science19Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_studyprograms_study_sports_science19 = /** @type {((inputs?: _Field__Enum_Studyprograms_Study_Sports_Science19Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Studyprograms_Study_Sports_Science19Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_studyprograms_study_sports_science19(inputs)
	return de__field__enum_studyprograms_study_sports_science19(inputs)
});
export { _field__enum_studyprograms_study_sports_science19 as "_field__enum_studyPrograms_STUDY_SPORTS_SCIENCE" }